export default "/images/press1.png?6717447a24c3e6838124549a10c0ca84";